// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"96":"8f9fdb12","105":"c309a3d5","163":"8e9f37f4","341":"f1903fd9","377":"01583788","387":"958faf4d","816":"24841f59"}[chunkId] + ".js";
};